var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import useForm from "@/Utils/useForm";
import moment from "moment";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import useTypedPage from "@/Hooks/useTypedPage";
import ClientFormForm from "@/Pages/ClientForm/Partials/ClientFormForm";
export default function ClientFormModal(_a) {
    var team = _a.team, branch = _a.branch, onClose = _a.onClose, _b = _a.clientForm, clientForm = _b === void 0 ? null : _b;
    var route = useRoute(Ziggy);
    var page = useTypedPage();
    var options = [{ name: "Schedule appointment date", value: true }, { name: "No date", value: false }];
    var form = useForm(clientForm ? clientForm : {
        client: null,
        schedule_appointment: true,
        appointment_date: moment().add(1, "day").format('YYYY-MM-DD 09:00:00'),
        reply_to: page.props.user.email,
    });
    var _c = useState(false), copied = _c[0], setCopied = _c[1];
    function cancel() {
        onClose();
        var currURL = window.location.href;
        var url = (currURL.split(window.location.host)[1]).split("?")[0];
        window.history.pushState({}, document.title, url);
    }
    function save() {
        var fn = form.data.id ? form.put : form.post;
        var url = form.data.id ? route('team.branch.client-form.update', { team: team, branch: branch, client_form: form.data.id }) : route('team.branch.client-form.store', { team: team, branch: branch });
        fn(url, {
            preserveState: false,
            onSuccess: function () {
            }
        });
    }
    function setCopiedWithTimeout() {
        setCopied(true);
        setTimeout(function () {
            setCopied(false);
        }, 3000);
    }
    function useNewClient() {
        form.setData('create_new_client', true);
    }
    return _jsxs("div", __assign({ className: "p-6 " }, { children: [_jsx(ClientFormForm, { team: team, branch: branch, form: form, onClose: onClose }), _jsxs("div", __assign({ className: "mt-5 flex justify-end" }, { children: [_jsx("button", __assign({ type: "button", className: "mt-3 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 sm:mt-0 sm:col-start-1 sm:text-sm", onClick: function () { return cancel(); } }, { children: "Cancel" })), _jsx("button", __assign({ type: "button", className: "ml-4 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-sky-600 text-base font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 sm:col-start-2 sm:text-sm", onClick: function () { return save(); } }, { children: form.data.id ? "Save" : "Create" }))] }))] }));
}
